
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.251 6.55H1v13.244h19.251V6.551zM6.066 6.297V4.973C6.066 2.766 8.093 1 10.626 1c2.533 0 4.56 1.766 4.56 3.973v1.324","stroke":"#fff","stroke-width":"2","stroke-miterlimit":"10"}})])
          )
        }
      }
    